export const UPCOMING_WORK_OCCURRENCES_COMMAND_ID = 'occurrences';

/** Which local dates one task works in [from, to] (YYYY-MM-DD, inclusive); horizon-capped server-side. */
export interface UpcomingWorkOccurrencesRequest {
    taskId: string;
    from: string;
    to: string;
}

export interface UpcomingWorkOccurrences {
    taskId: string;
    from: string;
    to: string;
    dueDates: string[];
}
